import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Category } from '@antv/gui';
import { last } from '@antv/util';
import { format } from 'd3-format';
import { Identity } from '@antv/scale';
import { useMarker } from '../utils/marker';
import { adaptor, domainOf, LegendCategoryLayout, inferComponentLayout, inferComponentShape, scaleOf, titleContent } from './utils';
function inferShape(scales, markState) {
  var shapeScale = scaleOf(scales, 'shape');
  var colorScale = scaleOf(scales, 'color');
  // NOTE!!!
  // scaleOrdinal.map will mute domain.
  var shapeScale1 = shapeScale ? shapeScale.clone() : null;
  // Infer the main shape if multiple marks are used.
  var shapes = [];
  var _iterator = _createForOfIteratorHelper(markState),
    _step;
  try {
    var _loop = function _loop() {
      var _step$value = _slicedToArray(_step.value, 2),
        mark = _step$value[0],
        state = _step$value[1];
      var namespace = mark.type;
      var domain = (colorScale === null || colorScale === void 0 ? void 0 : colorScale.getOptions().domain.length) > 0 ? colorScale === null || colorScale === void 0 ? void 0 : colorScale.getOptions().domain : state.data;
      var shape = domain.map(function (d, i) {
        var _a;
        if (shapeScale1) return shapeScale1.map(d || 'point');
        return ((_a = mark === null || mark === void 0 ? void 0 : mark.style) === null || _a === void 0 ? void 0 : _a.shape) || state.defaultShape || 'point';
      });
      if (typeof namespace === 'string') shapes.push([namespace, shape]);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (shapes.length === 0) return ['point', ['point']];
  if (shapes.length === 1) return shapes[0];
  if (!shapeScale) return shapes[0];
  // Evaluate the maximum likelihood of shape
  var _shapeScale$getOption = shapeScale.getOptions(),
    range = _shapeScale$getOption.range;
  return shapes.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      namespace = _ref2[0],
      shape = _ref2[1];
    var sum = 0;
    for (var i = 0; i < shapes.length; i++) {
      var targetShape = range[i % range.length];
      if (shape[i] === targetShape) sum++;
    }
    return [sum / shape.length, [namespace, shape]];
  }).sort(function (a, b) {
    return b[0] - a[0];
  })[0][1];
}
function inferItemMarker(options, context) {
  var scales = context.scales,
    library = context.library,
    markState = context.markState;
  var _inferShape = inferShape(scales, markState),
    _inferShape2 = _slicedToArray(_inferShape, 2),
    mark = _inferShape2[0],
    shapes = _inferShape2[1];
  var itemMarker = options.itemMarker,
    size = options.itemMarkerSize;
  var create = function create(name, d) {
    var _a, _b, _c;
    var marker = ((_c = (_b = (_a = library["mark.".concat(mark)]) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.shape[name]) === null || _c === void 0 ? void 0 : _c.props.defaultMarker) || last(name.split('.'));
    var radius = typeof size === 'function' ? size(d) : size;
    return function () {
      return useMarker(marker, {
        color: d.color
      })(0, 0, radius);
    };
  };
  var shapeOf = function shapeOf(i) {
    return "".concat(shapes[i]);
  };
  var shapeScale = scaleOf(scales, 'shape');
  if (shapeScale && !itemMarker) return function (d, i) {
    return create(shapeOf(i), d);
  };
  if (typeof itemMarker === 'function') {
    return function (d, i) {
      // @todo Fix this in GUI.
      // It should pass primitive value rather object.
      var node = itemMarker(d.id, i);
      if (typeof node === 'string') return create(node, d);
      return node;
    };
  }
  return function (d, i) {
    return create(itemMarker || shapeOf(i), d);
  };
}
function inferItemMarkerOpacity(scales) {
  var scale = scaleOf(scales, 'opacity');
  if (scale) {
    var _scale$getOptions = scale.getOptions(),
      range = _scale$getOptions.range;
    return function (d, i) {
      return range[i];
    };
  }
  return undefined;
}
function inferItemMarkerSize(scales, defaults) {
  var scale = scaleOf(scales, 'size');
  if (scale instanceof Identity) return scale.map(NaN) * 2;
  return defaults;
}
function inferCategoryStyle(options, context) {
  var _options$labelFormatt = options.labelFormatter,
    labelFormatter = _options$labelFormatt === void 0 ? function (d) {
      return "".concat(d);
    } : _options$labelFormatt;
  var scales = context.scales,
    theme = context.theme;
  var defaultSize = theme.legendCategory.itemMarkerSize;
  var itemMarkerSize = inferItemMarkerSize(scales, defaultSize);
  var baseStyle = {
    itemMarker: inferItemMarker(Object.assign(Object.assign({}, options), {
      itemMarkerSize: itemMarkerSize
    }), context),
    itemMarkerSize: itemMarkerSize,
    itemMarkerOpacity: inferItemMarkerOpacity(scales)
  };
  var finalLabelFormatter = typeof labelFormatter === 'string' ? format(labelFormatter) : labelFormatter;
  var colorScale = scaleOf(scales, 'color');
  var domain = domainOf(scales);
  var colorOf = colorScale ? function (d) {
    return colorScale.map(d);
  } : function () {
    return context.theme.color;
  };
  return Object.assign(Object.assign({}, baseStyle), {
    data: domain.map(function (d) {
      return {
        id: d,
        label: finalLabelFormatter(d),
        color: colorOf(d)
      };
    })
  });
}
function inferLegendShape(value, options, component) {
  var position = options.position;
  if (position === 'center') {
    var bbox = value.bbox; // to be confirm: if position is center, we should use the width and height of user definition.
    var _width = bbox.width,
      _height = bbox.height;
    return {
      width: _width,
      height: _height
    };
  }
  var _inferComponentShape = inferComponentShape(value, options, component),
    width = _inferComponentShape.width,
    height = _inferComponentShape.height;
  return {
    width: width,
    height: height
  };
}
/**
 * Guide Component for ordinal color scale.
 */
var _LegendCategory = function LegendCategory(options) {
  var labelFormatter = options.labelFormatter,
    layout = options.layout,
    order = options.order,
    orientation = options.orientation,
    position = options.position,
    size = options.size,
    title = options.title,
    cols = options.cols,
    itemMarker = options.itemMarker,
    style = __rest(options, ["labelFormatter", "layout", "order", "orientation", "position", "size", "title", "cols", "itemMarker"]);
  var gridRow = style.gridRow;
  return function (context) {
    var value = context.value,
      theme = context.theme;
    var bbox = value.bbox;
    var _inferLegendShape = inferLegendShape(value, options, _LegendCategory),
      width = _inferLegendShape.width,
      height = _inferLegendShape.height;
    var finalLayout = inferComponentLayout(position, layout);
    var legendStyle = Object.assign(Object.assign(Object.assign(Object.assign({
      orientation: ['right', 'left', 'center'].includes(position) ? 'vertical' : 'horizontal',
      width: width,
      height: height,
      layout: cols !== undefined ? 'grid' : 'flex'
    }, cols !== undefined && {
      gridCol: cols
    }), gridRow !== undefined && {
      gridRow: gridRow
    }), {
      titleText: titleContent(title)
    }), inferCategoryStyle(options, context));
    var _theme$legendCategory = theme.legendCategory,
      legendTheme = _theme$legendCategory === void 0 ? {} : _theme$legendCategory;
    var categoryStyle = adaptor(Object.assign({}, legendTheme, legendStyle, style));
    var layoutWrapper = new LegendCategoryLayout({
      style: Object.assign(Object.assign({
        x: bbox.x,
        y: bbox.y,
        width: bbox.width,
        height: bbox.height
      }, finalLayout), {
        // @ts-ignore
        subOptions: categoryStyle
      })
    });
    layoutWrapper.appendChild(new Category({
      className: 'legend-category',
      style: categoryStyle
    }));
    return layoutWrapper;
  };
};
export { _LegendCategory as LegendCategory };
_LegendCategory.props = {
  defaultPosition: 'top',
  defaultOrder: 1,
  defaultSize: 40,
  defaultCrossPadding: [12, 12],
  defaultPadding: [12, 12]
};